export default __webpack_public_path__ + "static/media/logo_big.96ef9eaf.png";